import { combineReducers } from "redux";

import agreementTableReducer from "./containers/AgreementsPage/reducers";
import errorReducer from "./containers/App/reducers";
import cardReducer from "./containers/CardPage/reducers";
import { fuelingProcessCancelEditReducer } from "./containers/FuelingProcessesPage/components/FuelingProcessCancelEdit/reducers";
import { fuelingProcessReceiptEditReducer } from "./containers/FuelingProcessesPage/components/FuelingProcessReceiptEdit/reducers";
import {
  exportToExcelReducer,
  fuelingProcessesDetailsReducer,
  fuelingProcessesTableReducer,
} from "./containers/FuelingProcessesPage/reducers";
import { importExportPricingReducer } from "./containers/PricingPage/reducers";
import sessionLoginReducer from "./containers/SessionLogin/reducer";
import stationMartsReducer from "./containers/StationMartsPage/reducers";
import {
  exportVendorStationsReducer,
  importExportStationsReducer,
} from "./containers/StationsPage/reducers";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    processes: combineReducers({
      detailState: fuelingProcessesDetailsReducer,
      tableState: fuelingProcessesTableReducer,
      exportToExcelState: exportToExcelReducer,
    }),
    processReceiptEdit: fuelingProcessReceiptEditReducer,
    processCancelEdit: fuelingProcessCancelEditReducer,
    card: cardReducer,
    session: sessionLoginReducer,
    stations: combineReducers({
      importExportStationsState: importExportStationsReducer,
      exportVendorStationsState: exportVendorStationsReducer,
    }),
    agreements: agreementTableReducer,
    stationMarts: stationMartsReducer,
    pricing: combineReducers({
      importExportPricingState: importExportPricingReducer,
    }),
    error: errorReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
